import {map, take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class GroupsService {

  constructor(private http: HttpClient,
              private apiService: ApiService) {}

  public getGroups() : Observable<any> {
    return this.http.get(this.apiService.getGroups()).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public getGroup(id) : Observable<any> {
    return this.http.get(this.apiService.getGroup(id)).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public getDevicesFromGroup(id) : Observable<any> {
    return this.http.get(this.apiService.getDevicesFromGroup(id)).pipe(take(1),map(value => {
      return value;
    }),);
  }


  public addGroup(group) : Observable<any> {
    return this.http.post(this.apiService.addGroup(), { group }).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public editGroup(id, group) : Observable<any> {
    return this.http.put(this.apiService.editGroup(id), { group }).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public deleteGroup(id) : Observable<any> {
    return this.http.delete(this.apiService.deleteGroup(id)).pipe(take(1),map(value => {
      return value;
    }),);
  }

  public assignDevices(id, devices) : Observable<any> {
    return this.http.put(this.apiService.assignDevicesToGroup(id), { devices }).pipe(take(1),map(value => {
      return value;
    }),);
  }
}
